import { motion } from 'framer-motion';
import { LayoutGrid, ImageIcon, UserSquare2 } from 'lucide-react';

const TABS = [
  { id: 'grid', icon: LayoutGrid, label: 'Gallery' },
  { id: 'albums', icon: ImageIcon, label: 'Albums' },
  { id: 'shared', icon: UserSquare2, label: 'Shared' },
];

const ProfileTabs = ({ active, onChange }) => (
  <div className="mt-5 border-b border-[#E9EEF7] dark:border-white/[0.06]">
    <div className="flex">
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const selected = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            aria-label={tab.label}
            className={`relative flex flex-1 items-center justify-center py-3 transition-colors ${
              selected
                ? 'text-surface-900 dark:text-white'
                : 'text-surface-400 hover:text-surface-600 dark:text-surface-500'
            }`}
          >
            <Icon size={22} strokeWidth={selected ? 2.25 : 1.75} />
            {selected && (
              <motion.span
                layoutId="profile-tab-underline"
                className="absolute bottom-0 left-1/2 h-[2.5px] w-12 -translate-x-1/2 rounded-full bg-surface-900 dark:bg-white"
                transition={{ type: 'spring', stiffness: 400, damping: 32 }}
              />
            )}
          </button>
        );
      })}
    </div>
  </div>
);

export default ProfileTabs;
